import { PAGE_TYPE_AREA, PAGE_TYPE_PROPERTY } from 'constants/index';

export const PAGE_TYPES_WITH_IMAGES = [PAGE_TYPE_PROPERTY, PAGE_TYPE_AREA];
